var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 6.6665H6.67484M3.80212 2.44755L2.44755 3.80212C2.1593 4.09037 2.01517 4.2345 1.9121 4.4027C1.82072 4.55182 1.75338 4.71439 1.71255 4.88445C1.6665 5.07626 1.6665 5.28009 1.6665 5.68774L1.6665 8.06193C1.6665 8.46958 1.6665 8.67341 1.71255 8.86522C1.75338 9.03528 1.82072 9.19786 1.9121 9.34698C2.01517 9.51517 2.1593 9.6593 2.44755 9.94755L8.83807 16.3381C9.82812 17.3281 10.3231 17.8231 10.894 18.0086C11.3961 18.1718 11.9369 18.1718 12.439 18.0086C13.0099 17.8231 13.5049 17.3281 14.4949 16.3381L16.3381 14.4949C17.3281 13.5049 17.8231 13.0099 18.0086 12.439C18.1718 11.9369 18.1718 11.3961 18.0086 10.894C17.8231 10.3231 17.3281 9.82812 16.3381 8.83807L9.94755 2.44755C9.6593 2.1593 9.51517 2.01517 9.34698 1.9121C9.19786 1.82072 9.03528 1.75338 8.86522 1.71255C8.67341 1.6665 8.46958 1.6665 8.06193 1.6665L5.68774 1.6665C5.28009 1.6665 5.07626 1.6665 4.88445 1.71255C4.71439 1.75338 4.55182 1.82072 4.4027 1.9121C4.2345 2.01517 4.09037 2.1593 3.80212 2.44755ZM7.08317 6.6665C7.08317 6.89662 6.89662 7.08317 6.6665 7.08317C6.43639 7.08317 6.24984 6.89662 6.24984 6.6665C6.24984 6.43639 6.43639 6.24984 6.6665 6.24984C6.89662 6.24984 7.08317 6.43639 7.08317 6.6665Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuOrders);
export default __webpack_public_path__ + "static/media/menu-orders.0b8a83039d0d77658554dfdbd5a97bc4.svg";
export { ForwardRef as ReactComponent };